import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import { viVN } from '@mui/material/locale';

import './styles/index.scss';
import { Provider } from 'react-redux';
import store from './redux/store';

const theme = createTheme(
    {
        palette: {
            success: {
                main: '#52c41a',
            },
            warning: {
                main: '#ff9800',
            },
            neutral: {
                main: '#64748B',
                contrastText: '#fff',
            },
            error: {
                main: '#ef5350',
            },
            primary: { main: '#2b713a' },
        },
    },
    viVN,
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <SnackbarProvider maxSnack={3}>
                <App />
            </SnackbarProvider>
        </ThemeProvider>
    </Provider>
);
